import * as fp from 'lodash/fp';

export enum LayoutSize {
    MOBILE, TABLET, DESKTOP
}

const getSizeByWidth = ( width ) => {
    if (width >= 1200) return LayoutSize.DESKTOP;
    if (width >= 768) return LayoutSize.TABLET;
    return LayoutSize.MOBILE;
};

export const getLayout = () : LayoutSize => {
    return getSizeByWidth( window.innerWidth )
};

let fns = [];
let layout = getLayout();
window.addEventListener('resize', () => {
    if ( getLayout() !== layout ) {
        layout = getLayout();
        fns.forEach( fn => fn( layout )  );
    }
});

export const onLayoutChange = (fn) => {
    fns = [fn, ...fns];

    return () => fns = fp.remove( fp.eq( fn ),  fns);
};



// WEBPACK FOOTER //
// ./resources/modules/cars/rating/tires/utils/layoutUtils.ts